module.exports = [
  {
    title: 'English',
    locale: 'en',
  },
  {
    title: 'Help translate',
    locale: 'eo-UY',
  },
]
